import { z } from 'zod';
import { TypeOfAPIError } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config/apiClientConfig';

const getRetryECardGeneration = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/admin/policy/:encryptedPolicyId/retry-ecard-generation',
		method: 'GET',
		requestParameters: { encryptedPolicyId: ['required', 'string'] },
		responseSchema: z.object({}).optional(),
		errorCodes: ['EcardDownLoadFailed'],
	});

export default getRetryECardGeneration;

export type GetRetryECardGenerationErrors = TypeOfAPIError<ReturnType<typeof getRetryECardGeneration>>;
